<div class="ul-filter menu">
  <form [formGroup]="changeCustomerFormGroup">
    <div class="zmenu-panel__heading zmenu-panel__heading--zblue">
      <i class="material-icons zmenu-panel__heading-icon zmenu-panel__heading-icon--zblue" (click)="goBack()"> cancel</i>
      <div class="zmenu-panel__heading--spacer">&nbsp;</div>
      <h2>Filter</h2>
      <div class="zmenu-panel__heading--spacer">&nbsp;</div>
      <i class="material-icons zmenu-panel__heading-icon zmenu-panel__heading-icon--zblue" (click)="resetForm()"> replay</i>
    </div>

    <div class="p-fluid p-grid">
      <div class="p-field p-col-12 p-mb-4 p-mt-6">
        <span class="p-float-label">
          <input type="text" id="custid" pInputText formControlName="custid" />
          <label for="custid">Customer</label>
        </span>
      </div>
    </div>
  </form>
</div>
